


































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { Spacing } from '../constants';
import FormError from './FormError.vue';
import FormInput from './FormInput.vue';
import FormLabel from './FormLabel.vue';
import FormSection from './FormSection.vue';

let i = 0;
// eslint-disable-next-line no-plusplus
const getId = () => `form-id-${i++}`;

export default defineComponent({
	components: {
		FormSection,
		FormInput,
		FormLabel,
		FormError,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		errorText: {
			type: [String, Boolean],
			default: '',
		},
		id: {
			type: String,
			default: null,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.WIDE,
		},
		required: Boolean,
		withHelp: Boolean,
		hideErrorField: Boolean,
	},
	setup(props) {
		const computedId = computed(() => (props.id === null ? getId() : props.id));
		const hasError = computed(() => Boolean(props.errorText));
		return {
			computedId,
			hasError,
		};
	},
});
